import * as React from "react";
const SvgFiRrPersonCarryBox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.5 5h-3A2.503 2.503 0 0 0 13 7.5V11h-1.382l-1.369-2.739A4.07 4.07 0 0 0 6.59 6 3.6 3.6 0 0 0 3 9.604l.054 3.78a3.97 3.97 0 0 0 1.938 3.371l2.524 1.518c.299.18.484.509.484.857v3.869a1 1 0 1 0 2 0V19.13a3.02 3.02 0 0 0-1.453-2.571L6.022 15.04a1.99 1.99 0 0 1-.968-1.686L5 9.588c0-.877.713-1.59 1.59-1.59q.21 0 .41.04v4.96a1 1 0 1 0 2 0v-2.765l.829 1.658a1.99 1.99 0 0 0 1.789 1.106H18.5c1.379 0 2.5-1.122 2.5-2.5v-3c0-1.378-1.121-2.5-2.5-2.5zm.5 5.5a.5.5 0 0 1-.5.5H15V7.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5zm-15-8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M6 20v3a1 1 0 1 1-2 0v-3a1 1 0 1 1 2 0"
    />
  </svg>
);
export default SvgFiRrPersonCarryBox;
